import { nativeAssets } from './signal';

export const useNativeAssets = () => {
  if (!nativeAssets.value) {
    return null;
  }

  return nativeAssets.value;
};
